
  export default {
    props: {
      alwaysExpandAtWidth: { type: Number, default: 1024 },
      cssClass: { type: String, default: '' },
      defaultExpanded: { type: Boolean, default: false },
      label: { type: String, required: true },
      transitionName: { type: String, default: null }
    },
    data () { return { expanded: false }; },
    computed: {
      windowWidth () { return this.$store.getters['utils/windowWidth']; }
    },
    watch: {
      windowWidth (value) {
        if (value > this.alwaysExpandAtWidth) this.expanded = true;
      }
    },
    mounted () {
      if (this.defaultExpanded) this.expanded = true;
      if (this.windowWidth > this.alwaysExpandAtWidth) {
        this.expanded = true;
      }
    },
    methods: {
      toggleExpanding () {
        if (this.windowWidth > this.alwaysExpandAtWidth) return;
        this.expanded = !this.expanded;
      }
    }
  };
